/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var spine_core_command_pb = require('../../../spine/core/command_pb.js');
var spine_core_event_pb = require('../../../spine/core/event_pb.js');
var spine_client_entities_pb = require('../../../spine/client/entities_pb.js');
var spine_server_entity_entity_pb = require('../../../spine/server/entity/entity_pb.js');
goog.exportSymbol('proto.spine.system.server.DispatchedMessageId', null, global);
goog.exportSymbol('proto.spine.system.server.DispatchingHistory', null, global);
goog.exportSymbol('proto.spine.system.server.EntityHistory', null, global);
goog.exportSymbol('proto.spine.system.server.EntityHistoryId', null, global);
goog.exportSymbol('proto.spine.system.server.LifecycleHistory', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityHistoryId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EntityHistoryId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityHistoryId.displayName = 'proto.spine.system.server.EntityHistoryId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityHistoryId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityHistoryId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityHistoryId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityHistoryId.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && spine_client_entities_pb.EntityId.toObject(includeInstance, f),
    typeUrl: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityHistoryId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityHistoryId;
  return proto.spine.system.server.EntityHistoryId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityHistoryId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityHistoryId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_client_entities_pb.EntityId;
      reader.readMessage(value,spine_client_entities_pb.EntityId.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityHistoryId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityHistoryId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityHistoryId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityHistoryId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_client_entities_pb.EntityId.serializeBinaryToWriter
    );
  }
  f = message.getTypeUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional spine.client.EntityId entity_id = 1;
 * @return {?proto.spine.client.EntityId}
 */
proto.spine.system.server.EntityHistoryId.prototype.getEntityId = function() {
  return /** @type{?proto.spine.client.EntityId} */ (
    jspb.Message.getWrapperField(this, spine_client_entities_pb.EntityId, 1));
};


/** @param {?proto.spine.client.EntityId|undefined} value */
proto.spine.system.server.EntityHistoryId.prototype.setEntityId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityHistoryId.prototype.clearEntityId = function() {
  this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityHistoryId.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string type_url = 2;
 * @return {string}
 */
proto.spine.system.server.EntityHistoryId.prototype.getTypeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.spine.system.server.EntityHistoryId.prototype.setTypeUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EntityHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityHistory.displayName = 'proto.spine.system.server.EntityHistory';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.system.server.EntityHistoryId.toObject(includeInstance, f),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lifecycle: (f = msg.getLifecycle()) && proto.spine.system.server.LifecycleHistory.toObject(includeInstance, f),
    lastStateChange: (f = msg.getLastStateChange()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dispatching: (f = msg.getDispatching()) && proto.spine.system.server.DispatchingHistory.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityHistory}
 */
proto.spine.system.server.EntityHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityHistory;
  return proto.spine.system.server.EntityHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityHistory}
 */
proto.spine.system.server.EntityHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.system.server.EntityHistoryId;
      reader.readMessage(value,proto.spine.system.server.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.EntityOption.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = new proto.spine.system.server.LifecycleHistory;
      reader.readMessage(value,proto.spine.system.server.LifecycleHistory.deserializeBinaryFromReader);
      msg.setLifecycle(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastStateChange(value);
      break;
    case 5:
      var value = new proto.spine.system.server.DispatchingHistory;
      reader.readMessage(value,proto.spine.system.server.DispatchingHistory.deserializeBinaryFromReader);
      msg.setDispatching(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.system.server.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLifecycle();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.spine.system.server.LifecycleHistory.serializeBinaryToWriter
    );
  }
  f = message.getLastStateChange();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDispatching();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.spine.system.server.DispatchingHistory.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityHistory.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, proto.spine.system.server.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityHistory.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityHistory.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityHistory.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EntityOption.Kind kind = 2;
 * @return {!proto.EntityOption.Kind}
 */
proto.spine.system.server.EntityHistory.prototype.getKind = function() {
  return /** @type {!proto.EntityOption.Kind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.EntityOption.Kind} value */
proto.spine.system.server.EntityHistory.prototype.setKind = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional LifecycleHistory lifecycle = 3;
 * @return {?proto.spine.system.server.LifecycleHistory}
 */
proto.spine.system.server.EntityHistory.prototype.getLifecycle = function() {
  return /** @type{?proto.spine.system.server.LifecycleHistory} */ (
    jspb.Message.getWrapperField(this, proto.spine.system.server.LifecycleHistory, 3));
};


/** @param {?proto.spine.system.server.LifecycleHistory|undefined} value */
proto.spine.system.server.EntityHistory.prototype.setLifecycle = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EntityHistory.prototype.clearLifecycle = function() {
  this.setLifecycle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityHistory.prototype.hasLifecycle = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp last_state_change = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityHistory.prototype.getLastStateChange = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityHistory.prototype.setLastStateChange = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.system.server.EntityHistory.prototype.clearLastStateChange = function() {
  this.setLastStateChange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityHistory.prototype.hasLastStateChange = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DispatchingHistory dispatching = 5;
 * @return {?proto.spine.system.server.DispatchingHistory}
 */
proto.spine.system.server.EntityHistory.prototype.getDispatching = function() {
  return /** @type{?proto.spine.system.server.DispatchingHistory} */ (
    jspb.Message.getWrapperField(this, proto.spine.system.server.DispatchingHistory, 5));
};


/** @param {?proto.spine.system.server.DispatchingHistory|undefined} value */
proto.spine.system.server.EntityHistory.prototype.setDispatching = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.spine.system.server.EntityHistory.prototype.clearDispatching = function() {
  this.setDispatching(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityHistory.prototype.hasDispatching = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.LifecycleHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.LifecycleHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.LifecycleHistory.displayName = 'proto.spine.system.server.LifecycleHistory';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.LifecycleHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.LifecycleHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.LifecycleHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.LifecycleHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    lifecycleFlags: (f = msg.getLifecycleFlags()) && spine_server_entity_entity_pb.LifecycleFlags.toObject(includeInstance, f),
    whenArchived: (f = msg.getWhenArchived()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    whenDeleted: (f = msg.getWhenDeleted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    whenExtractedFromArchive: (f = msg.getWhenExtractedFromArchive()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    whenRestored: (f = msg.getWhenRestored()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.LifecycleHistory}
 */
proto.spine.system.server.LifecycleHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.LifecycleHistory;
  return proto.spine.system.server.LifecycleHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.LifecycleHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.LifecycleHistory}
 */
proto.spine.system.server.LifecycleHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_server_entity_entity_pb.LifecycleFlags;
      reader.readMessage(value,spine_server_entity_entity_pb.LifecycleFlags.deserializeBinaryFromReader);
      msg.setLifecycleFlags(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenArchived(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDeleted(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenExtractedFromArchive(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenRestored(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.LifecycleHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.LifecycleHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.LifecycleHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.LifecycleHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLifecycleFlags();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_server_entity_entity_pb.LifecycleFlags.serializeBinaryToWriter
    );
  }
  f = message.getWhenArchived();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWhenDeleted();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWhenExtractedFromArchive();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWhenRestored();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.server.entity.LifecycleFlags lifecycle_flags = 1;
 * @return {?proto.spine.server.entity.LifecycleFlags}
 */
proto.spine.system.server.LifecycleHistory.prototype.getLifecycleFlags = function() {
  return /** @type{?proto.spine.server.entity.LifecycleFlags} */ (
    jspb.Message.getWrapperField(this, spine_server_entity_entity_pb.LifecycleFlags, 1));
};


/** @param {?proto.spine.server.entity.LifecycleFlags|undefined} value */
proto.spine.system.server.LifecycleHistory.prototype.setLifecycleFlags = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.LifecycleHistory.prototype.clearLifecycleFlags = function() {
  this.setLifecycleFlags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.LifecycleHistory.prototype.hasLifecycleFlags = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp when_archived = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.LifecycleHistory.prototype.getWhenArchived = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.LifecycleHistory.prototype.setWhenArchived = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.LifecycleHistory.prototype.clearWhenArchived = function() {
  this.setWhenArchived(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.LifecycleHistory.prototype.hasWhenArchived = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_deleted = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.LifecycleHistory.prototype.getWhenDeleted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.LifecycleHistory.prototype.setWhenDeleted = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.LifecycleHistory.prototype.clearWhenDeleted = function() {
  this.setWhenDeleted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.LifecycleHistory.prototype.hasWhenDeleted = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp when_extracted_from_archive = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.LifecycleHistory.prototype.getWhenExtractedFromArchive = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.LifecycleHistory.prototype.setWhenExtractedFromArchive = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.system.server.LifecycleHistory.prototype.clearWhenExtractedFromArchive = function() {
  this.setWhenExtractedFromArchive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.LifecycleHistory.prototype.hasWhenExtractedFromArchive = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp when_restored = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.LifecycleHistory.prototype.getWhenRestored = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.LifecycleHistory.prototype.setWhenRestored = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


proto.spine.system.server.LifecycleHistory.prototype.clearWhenRestored = function() {
  this.setWhenRestored(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.LifecycleHistory.prototype.hasWhenRestored = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.DispatchingHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.DispatchingHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.DispatchingHistory.displayName = 'proto.spine.system.server.DispatchingHistory';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.DispatchingHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.DispatchingHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.DispatchingHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchingHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    whenCommand: (f = msg.getWhenCommand()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    whenEvent: (f = msg.getWhenEvent()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.DispatchingHistory}
 */
proto.spine.system.server.DispatchingHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.DispatchingHistory;
  return proto.spine.system.server.DispatchingHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.DispatchingHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.DispatchingHistory}
 */
proto.spine.system.server.DispatchingHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenCommand(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.DispatchingHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.DispatchingHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.DispatchingHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchingHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWhenCommand();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getWhenEvent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp when_command = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.DispatchingHistory.prototype.getWhenCommand = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.DispatchingHistory.prototype.setWhenCommand = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.DispatchingHistory.prototype.clearWhenCommand = function() {
  this.setWhenCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchingHistory.prototype.hasWhenCommand = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp when_event = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.DispatchingHistory.prototype.getWhenEvent = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.DispatchingHistory.prototype.setWhenEvent = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.DispatchingHistory.prototype.clearWhenEvent = function() {
  this.setWhenEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchingHistory.prototype.hasWhenEvent = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.DispatchedMessageId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.spine.system.server.DispatchedMessageId.oneofGroups_);
};
goog.inherits(proto.spine.system.server.DispatchedMessageId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.DispatchedMessageId.displayName = 'proto.spine.system.server.DispatchedMessageId';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.spine.system.server.DispatchedMessageId.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.spine.system.server.DispatchedMessageId.KindCase = {
  KIND_NOT_SET: 0,
  COMMAND_ID: 1,
  EVENT_ID: 2
};

/**
 * @return {proto.spine.system.server.DispatchedMessageId.KindCase}
 */
proto.spine.system.server.DispatchedMessageId.prototype.getKindCase = function() {
  return /** @type {proto.spine.system.server.DispatchedMessageId.KindCase} */(jspb.Message.computeOneofCase(this, proto.spine.system.server.DispatchedMessageId.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.DispatchedMessageId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.DispatchedMessageId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.DispatchedMessageId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchedMessageId.toObject = function(includeInstance, msg) {
  var f, obj = {
    commandId: (f = msg.getCommandId()) && spine_core_command_pb.CommandId.toObject(includeInstance, f),
    eventId: (f = msg.getEventId()) && spine_core_event_pb.EventId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.DispatchedMessageId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.DispatchedMessageId;
  return proto.spine.system.server.DispatchedMessageId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.DispatchedMessageId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.DispatchedMessageId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.setCommandId(value);
      break;
    case 2:
      var value = new spine_core_event_pb.EventId;
      reader.readMessage(value,spine_core_event_pb.EventId.deserializeBinaryFromReader);
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.DispatchedMessageId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.DispatchedMessageId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.DispatchedMessageId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.DispatchedMessageId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommandId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
  f = message.getEventId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.EventId.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.CommandId command_id = 1;
 * @return {?proto.spine.core.CommandId}
 */
proto.spine.system.server.DispatchedMessageId.prototype.getCommandId = function() {
  return /** @type{?proto.spine.core.CommandId} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandId, 1));
};


/** @param {?proto.spine.core.CommandId|undefined} value */
proto.spine.system.server.DispatchedMessageId.prototype.setCommandId = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.spine.system.server.DispatchedMessageId.oneofGroups_[0], value);
};


proto.spine.system.server.DispatchedMessageId.prototype.clearCommandId = function() {
  this.setCommandId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchedMessageId.prototype.hasCommandId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.EventId event_id = 2;
 * @return {?proto.spine.core.EventId}
 */
proto.spine.system.server.DispatchedMessageId.prototype.getEventId = function() {
  return /** @type{?proto.spine.core.EventId} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.EventId, 2));
};


/** @param {?proto.spine.core.EventId|undefined} value */
proto.spine.system.server.DispatchedMessageId.prototype.setEventId = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.spine.system.server.DispatchedMessageId.oneofGroups_[0], value);
};


proto.spine.system.server.DispatchedMessageId.prototype.clearEventId = function() {
  this.setEventId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.DispatchedMessageId.prototype.hasEventId = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.system.server.EntityHistoryId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityHistoryId.fromObject(jsObject);
};

proto.spine.system.server.EntityHistoryId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityHistoryId();
  
  if (obj.entityId !== undefined) {
    if (obj.entityId === null) {
      msg.setEntityId(null);
    } else {
      let value = proto.spine.client.EntityId.fromObject(obj.entityId);
      msg.setEntityId(value);
    }
  }
  
  if (obj.typeUrl !== undefined) {
    if (obj.typeUrl !== null) {
      let value = obj.typeUrl;
      msg.setTypeUrl(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityHistory.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityHistory.fromObject(jsObject);
};

proto.spine.system.server.EntityHistory.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityHistory();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.kind !== undefined) {
    if (obj.kind !== null) {
      let value = proto.EntityOption.Kind[obj.kind];
      msg.setKind(value);
    }
  }
  
  if (obj.lifecycle !== undefined) {
    if (obj.lifecycle === null) {
      msg.setLifecycle(null);
    } else {
      let value = proto.spine.system.server.LifecycleHistory.fromObject(obj.lifecycle);
      msg.setLifecycle(value);
    }
  }
  
  if (obj.lastStateChange !== undefined) {
    if (obj.lastStateChange === null) {
      msg.setLastStateChange(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.lastStateChange);
      msg.setLastStateChange(value);
    }
  }
  
  if (obj.dispatching !== undefined) {
    if (obj.dispatching === null) {
      msg.setDispatching(null);
    } else {
      let value = proto.spine.system.server.DispatchingHistory.fromObject(obj.dispatching);
      msg.setDispatching(value);
    }
  }
  return msg;
};

proto.spine.system.server.LifecycleHistory.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.LifecycleHistory.fromObject(jsObject);
};

proto.spine.system.server.LifecycleHistory.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.LifecycleHistory();
  
  if (obj.lifecycleFlags !== undefined) {
    if (obj.lifecycleFlags === null) {
      msg.setLifecycleFlags(null);
    } else {
      let value = proto.spine.server.entity.LifecycleFlags.fromObject(obj.lifecycleFlags);
      msg.setLifecycleFlags(value);
    }
  }
  
  if (obj.whenArchived !== undefined) {
    if (obj.whenArchived === null) {
      msg.setWhenArchived(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenArchived);
      msg.setWhenArchived(value);
    }
  }
  
  if (obj.whenDeleted !== undefined) {
    if (obj.whenDeleted === null) {
      msg.setWhenDeleted(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDeleted);
      msg.setWhenDeleted(value);
    }
  }
  
  if (obj.whenExtractedFromArchive !== undefined) {
    if (obj.whenExtractedFromArchive === null) {
      msg.setWhenExtractedFromArchive(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenExtractedFromArchive);
      msg.setWhenExtractedFromArchive(value);
    }
  }
  
  if (obj.whenRestored !== undefined) {
    if (obj.whenRestored === null) {
      msg.setWhenRestored(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenRestored);
      msg.setWhenRestored(value);
    }
  }
  return msg;
};

proto.spine.system.server.DispatchingHistory.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.DispatchingHistory.fromObject(jsObject);
};

proto.spine.system.server.DispatchingHistory.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.DispatchingHistory();
  
  if (obj.whenCommand !== undefined) {
    if (obj.whenCommand === null) {
      msg.setWhenCommand(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenCommand);
      msg.setWhenCommand(value);
    }
  }
  
  if (obj.whenEvent !== undefined) {
    if (obj.whenEvent === null) {
      msg.setWhenEvent(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenEvent);
      msg.setWhenEvent(value);
    }
  }
  return msg;
};

proto.spine.system.server.DispatchedMessageId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.DispatchedMessageId.fromObject(jsObject);
};

proto.spine.system.server.DispatchedMessageId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.DispatchedMessageId();
  
  if (obj.commandId !== undefined) {
    if (obj.commandId === null) {
      msg.setCommandId(null);
    } else {
      let value = proto.spine.core.CommandId.fromObject(obj.commandId);
      msg.setCommandId(value);
    }
  }
  
  if (obj.eventId !== undefined) {
    if (obj.eventId === null) {
      msg.setEventId(null);
    } else {
      let value = proto.spine.core.EventId.fromObject(obj.eventId);
      msg.setEventId(value);
    }
  }
  return msg;
};
